import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n/i18n";
import { RequireRole } from "@/components/auth/RequireRole";
import Empresas from "@/pages/Empresas";
import EmpresaPerfil from "@/pages/EmpresaPerfil";
import Favoritos from "@/pages/Favoritos";
import PasswordReset from "@/pages/PasswordReset";
import EmpresaInscripcion from "@/pages/EmpresaInscripcion";
import EmpresaSolicitud from "@/pages/EmpresaSolicitud";
import Backoffice from "@/pages/Backoffice";
import Home from "@/pages/Home";
import Registro from "@/pages/Registro";
import Credencial from "@/pages/Credencial";
import Acceso from "@/pages/Acceso";
import EmpresaScanner from "@/pages/EmpresaScanner";
import EmpresaPortal from "@/pages/EmpresaPortal";
import DashboardUPV from "@/pages/DashboardUPV";
import Login from "@/pages/Login";
import Activar from "@/pages/Activar";
import QrEmpresa from "@/pages/QrEmpresa";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const STAFF = ["upv_admin", "upv_staff"];
const ADMIN = ["upv_admin"];
const COMPANY = ["company"];

function App() {
  return (
    <div className="App">
      <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/activar/:token" element={<Activar />} />
            <Route path="/recuperar" element={<PasswordReset />} />
            <Route path="/restablecer/:token" element={<PasswordReset />} />
            <Route path="/q/:token" element={<QrEmpresa />} />
            <Route path="/favoritos/:token" element={<Favoritos />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/credencial" element={<RequireRole roles={["participant"]}><Credencial /></RequireRole>} />
            <Route path="/acceso" element={<RequireRole roles={STAFF}><Acceso /></RequireRole>} />
            <Route path="/empresa/scanner" element={<RequireRole roles={COMPANY} needCompany><EmpresaScanner /></RequireRole>} />
            <Route path="/empresa/portal" element={<RequireRole roles={COMPANY} needCompany><EmpresaPortal /></RequireRole>} />
            <Route path="/dashboard" element={<RequireRole roles={ADMIN}><DashboardUPV /></RequireRole>} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/empresas/inscripcion" element={<EmpresaInscripcion />} />
            <Route path="/empresas/inscripcion/:appId" element={<RequireRole roles={COMPANY}><EmpresaSolicitud /></RequireRole>} />
            <Route path="/empresas/inscripcion/:appId/editar" element={<RequireRole roles={COMPANY}><EmpresaInscripcion /></RequireRole>} />
            <Route path="/backoffice" element={<RequireRole roles={ADMIN}><Backoffice /></RequireRole>} />
            <Route path="/empresas/:id" element={<EmpresaPerfil />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
